let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aFMAu")).then(() => parcelRequire('10yxD'));